import { railModeVar, isRailOpenVar } from 'apollo/cache'
import { RailModes } from '..'

const railModeAction = (mode: RailModes, action: boolean) => {
  railModeVar(mode)
  isRailOpenVar(action)
}

export default railModeAction
